<template>
  <div>
    <div v-if="!id">
      <AlertPop/>
    </div>
    <div class="limiter" v-if="id">
      <div class="image">
        <img src="../assets/logo/logo.png" alt="Logo">
      </div>

      <div class="title">
        <h1>
          <span class="login100-form-title">Select a payment method</span>
        </h1>
      </div>

      <div class="container-login100">
        <div class="wrap-login100">
          <div class="form-summary">
            <h2 style="color: #3A6898">Details</h2>
            <div class="form-group">
              <p class="summary-item"><strong>Customer name:</strong> {{ customerName }}</p>
              <p class="summary-item"><strong>Sale Total: K</strong> {{ $utils.formatMoney(quoteTotal) }}</p>
              <button type="button" class="login100-form-btn" @click="openquote">View quote</button>

            </div>
          </div>
        </div>
      </div>

      <div class="mycon">
        <div class="card">
          <div class="card-body">
            <h5 class="card-title">Pay Full at {{discount}}% Discount</h5>
            <p class="card-text">This means you have the full amount and are going to pay it all.</p>
            <button type="button" class="login100-form-btn" @click="handleClick('full')">Pay Full Amount</button>
          </div>

        </div>
        <div class="card">
          <div class="card-body">
            <h5 class="card-title">Deposit (No Discount)</h5>
            <p class="card-text">This means you are not paying the full amounts there for no discounts.</p>
            <button type="button" class="login100-form-btn" @click="handleClick('deposit')">Deposit</button>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import 'bootstrap/dist/css/bootstrap.min.css';
import AlertPop from "@/components/AlertPop.vue";
import axios from "axios";
import {errorHandler} from "@/services/errorHandler";

export default {
  name: 'MyComponent',
  async beforeMount() {
    this.fetchDebtor()
  },
  data() {
    return {
      id: undefined,
      url: this.$route.query.url,
      saletotal: '',
      customerName:'',
      discount:'',
      quoteTotal:'',

    }
  },
  components: {
    AlertPop
  },
  methods: {
    fetchDebtor(){
      let auth = this.$route.query.auth;
      if (auth){
        auth = window.atob(auth);
        auth = JSON.parse(auth);
        this.id = auth.quoteNumber;
        localStorage.setItem(`DB`,auth.DB)
      }

      this.$store.commit(`setLoadingState`, true);
      return this.$store.dispatch('fetchDebtor',this.id)
          .then((data) => {
            this.saletotal = data.quoteTotal;
            this.discount = data.discountRate;
            this.amountToPay = data.paymentTotal;
            this.customerName = data.customerName;
            this.quoteTotal = data.quoteTotal;
          })
          .finally(()=> this.$store.commit(`setLoadingState`, false))
    },
    handleClick(type) {
      const route = {
        name: type === 'full' ? 'PaymentDetails' : 'Deposite',
        query: {id: this.id}
      };

      if (this.$route.name !== route.name) {
        this.$router.push(route);
      }
    },
    openquote() {
      this.$store.dispatch('openquote',this.id)
    },
  }

}
</script>

<style scoped>
.limiter {
  display: flex;
  flex-direction: column;
  align-items: center; /* Center content horizontally */
  padding: 20px;
}

.title {
  width: 100%;
  text-align: center; /* Center text horizontally */
  margin-bottom: 20px; /* Space between title and content */
}

.mycon {
  display: flex;
  justify-content: center;
  align-items: center;
  gap: 20px; /* Add space between cards */
  flex-wrap: wrap; /* Allow cards to wrap if necessary */
}

.card {
  flex: 1;
  min-width: 250px; /* Adjust as needed for responsiveness */
  max-width: 300px; /* Adjust as needed */
}
.limiter {
  display: flex;
  flex-direction: column;
  align-items: center;
  padding: 20px;
}

.container-login100 {
  width: 100%; /* Ensures the container takes full width */
  display: flex;
  justify-content: center; /* Center the content */
}

.wrap-login100 {
  max-width: 630px; /* Maximum width on larger screens */
  min-width: 200px;  /* Minimum width on smaller screens */
  width: 100%; /* Allow the container to be responsive */
}
@media (max-width: 561px) {
  .wrap-login100 {
    max-width: 300px; /* Maximum width on larger screens */
    min-width: 200px;  /* Minimum width on smaller screens */
    width: 100%; /* Allow the container to be responsive */
  }
}
</style>
